// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1973882b","453":"2e60cb6d","667":"e22bccd9"}[chunkId] + ".chunk.js";
};